MobileHelpers = LP.module 'MobileHelpers'

MobileHelpers.bindBackToTopButton = ->
 if LP.isPhone()
    $(window).scroll ->
      if $(this).scrollTop() > 450
        $('.back-to-top-button').fadeIn 300
      else
        $('.back-to-top-button').fadeOut 300
      return

    $('.back-to-top-button').click (e) ->
      e.preventDefault()
      $('html, body').animate { scrollTop: 0 }, 300
